import { injectable } from "inversify";
import AIRepository from "../../repositories/AIRepository";

interface props { aiRepository: AIRepository; }

@injectable()
export class GetAIChatsByCustomerUseCase {
    _aiRepository: AIRepository;
    constructor(_: props) { this._aiRepository = _.aiRepository; }
    public call = async (query: any, type: string, params: string): Promise<any> => {
        return await this._aiRepository.getAIChatsByCustomer(query, type, params);
    }
}
export const GetAIChatsByCustomerUseCaseName = "GetAIChatsByCustomerUseCaseName";
